export default __webpack_public_path__ + "static/media/Etape10_LaMaraichere_Before_Filtre_1.24125387.jpg";